const authConfig = {
	auth: {
		clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
		authority: process.env.REACT_APP_MSAL_AUTHORITY,
		redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
};

export default authConfig;
